import { Alert, Button } from "antd";

/** Rendering nothing is indistinguishable from a merchant Adyen has no state for. */
export default function AdyenDocumentStateAlert({
  error,
  onRetry,
  style,
}: {
  error: string;
  onRetry: () => void;
  style?: React.CSSProperties;
}) {
  return (
    <Alert
      type="warning"
      showIcon
      style={style}
      message="Adyen document state could not be read"
      description={error}
      action={
        <Button size="small" onClick={onRetry}>
          Retry
        </Button>
      }
    />
  );
}
